export default "__VITE_ASSET__DQThXmqZ__"